import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLeaderboard } from '../../store/thunks/leaderboardThunk';
import { setTimeframe } from '../../store/slices/leaderboardSlice';

const LeaderBoard = () => {
    const dispatch = useDispatch();
    const [fetchError, setFetchError] = useState(null);
    const { 
        weeklyLeaders, 
        monthlyLeaders, 
        yearlyLeaders, 
        loading, 
        error, 
        timeframe 
    } = useSelector(state => state.leaderboard);

    useEffect(() => {
        const loadLeaderboard = async () => {
            try {
                await dispatch(fetchLeaderboard(timeframe)).unwrap();
            } catch (err) {
                console.error('Error fetching leaderboard:', err);
                setFetchError(err.message || 'Failed to load leaderboard');
            }
        };
        
        loadLeaderboard();
    }, [dispatch, timeframe]);
    
    const getCurrentLeaderboard = () => {
        switch(timeframe) {
            case 'week':
                return weeklyLeaders;
            case 'month':
                return monthlyLeaders;
            case 'year':
                return yearlyLeaders;
            default:
                return [];
        }
    };

    const handleTimeframeChange = (newTimeframe) => {
        dispatch(setTimeframe(newTimeframe));
    };

    return (
        <div className="bg-white rounded-lg p-4 shadow-sm">
            <div className="flex justify-between items-center mb-4">
                <h2 className="font-display text-xl font-bold">Leaderboard</h2>
                <div className="flex space-x-2">
                    <button 
                        className={`px-3 py-1 rounded ${timeframe === 'week' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
                        onClick={() => handleTimeframeChange('week')}
                    >
                        Week
                    </button>
                    <button 
                        className={`px-3 py-1 rounded ${timeframe === 'month' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
                        onClick={() => handleTimeframeChange('month')}
                    >
                        Month
                    </button>
                    <button 
                        className={`px-3 py-1 rounded ${timeframe === 'year' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
                        onClick={() => handleTimeframeChange('year')}
                    >
                        Year
                    </button>
                </div>
            </div>
            
            {loading && (
                <div className="text-center py-4">Loading...</div>
            )}
            
            {error && (
                <div className="text-center text-red-500 py-4">{error}</div>
            )}
            
            <div className="space-y-2">
                <div className="text-center text-gray-500 py-4">
                    Coming soon
                </div>
            </div>
        </div>
    );
};

export default LeaderBoard;